import React, { useEffect } from 'react';
import { locales } from '../../../translations/locales';
import { _$ } from '../../../controllers/dom';

const Manning = (props) => {
    const { locale, vehicle, ModuleRP, players } = props;

    const updateManning = (updateType, playerId, skill) => {
        ModuleRP.updateManning(updateType, vehicle.id, playerId || _$('select-player').value, skill);
        if (updateType === 'pull') {
            vehicle.manning.find((m) => m.skill === skill && m.player.id === playerId).player = null;
        } else if (updateType === 'update') {
            vehicle.manning.find((m) => m.skill === skill).player = players.find((p) => p.id === _$('select-player').value);
        }
    };

    useEffect(() => {

    }, [vehicle]);

    return (
        <div>
            {vehicle && vehicle.manning &&
                vehicle.manning.map((manning, index) => {
                    return (
                        <div key={index}
                            className='row border-bottom p-1'
                        >
                            <div
                                className={`col-4 text-left ${manning.required ? 'text-danger' : 'text-secondary'}`}
                            >
                                {manning.skill.split('_#2')[0]}
                            </div>
                            <div className='col-4 text-left'>
                                {
                                    manning.player ? (
                                        manning.player.name
                                    ) : (
                                        <select
                                            className='form-control form-control-sm'
                                            id='select-player'
                                        >
                                            {
                                                players.map((player, index) => {
                                                    if (
                                                        player.assignments.includes(vehicle.buildingId) &&
                                                        player.status === ModuleRP.listStatus.find((s) => s.system === 'ONCALL').code
                                                    ) {
                                                        return (
                                                            <option key={index} value={player.id}>
                                                                {player.name}
                                                            </option>
                                                        );
                                                    }
                                                })
                                            }
                                        </select>
                                    )
                                }
                            </div>
                            <div className='col-4 text-left'>
                                {
                                    manning.player ? (
                                        <button
                                            type='button'
                                            className='btn btn-danger btn-sm p-1 m-1'
                                            onClick={() => updateManning('pull', manning.player.id, manning.skill)}
                                        >
                                            {locales[locale].sgo.pull}
                                        </button>
                                    ) : (
                                        <button
                                            type='button'
                                            className='btn btn-primary btn-sm p-1 m-1'
                                            onClick={() => updateManning('update', null, manning.skill)}
                                        >
                                            {locales[locale].config.update}
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    );
                })
            }
        </div>
    );
};

export default Manning;
